import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Paper, Button, Grid, Table, TableHead, TableRow, TableCell, TableBody, CircularProgress } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { profileActionCreators } from '../../actions/profileActionCreators';
import { getLoggedUser } from '../../helpers';
import { LinkContainer } from 'react-router-bootstrap';
import Moment from 'react-moment';
import { withTranslation } from 'react-i18next'; // Import withTranslation

const styles = theme => ({
    root: {
        paddingTop: theme.spacing.unit * 2,
        [theme.breakpoints.down("xs")]: {
            marginLeft: -50,
            marginRight: -50
        }
    },
    heading: {
        marginBottom: 40,
        marginTop: 40,
    },
});

class EmployerOffers extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentWillMount() {
        const loggedUser = getLoggedUser();

        this.props.requestStudentWithOffers(loggedUser.id);
    }

    render() {
        const { classes, theme, isLoading, t } = this.props; // Use t for translations
        const loggedUser = getLoggedUser();
        const student = this.props.student;

        if (!loggedUser && !loggedUser.token) {
            return (null);
        } else {

            return (isLoading ? <CircularProgress /> :
                <div>
                    <Grid
                        container
                        spacing={0}
                        alignItems="center"
                        justify="center"
                    >
                        <Grid item xs={8}>
                            <Paper className={classes.root}>
                                <Typography variant="h4" align="center" className={classes.heading}>
                                    {t('myJobOffers')} {/* Translated heading */}
                                </Typography>
                                <Grid item xs={12}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>{t('title')}</TableCell> {/* Translated table header */}
                                                <TableCell>{t('uploadedOn')}</TableCell> {/* Translated table header */}
                                                <TableCell>{t('expiresOn')}</TableCell> {/* Translated table header */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {student.jobsAppliedFor && student.jobsAppliedFor.length > 0 ?
                                                student.jobsAppliedFor.map(offer =>
                                                    <TableRow key={offer.jobOffer.id}>
                                                        <TableCell>
                                                            <LinkContainer to={`/job/details/${offer.jobOffer.id}`} exact>
                                                                <Button>{offer.jobOffer.title}</Button>
                                                            </LinkContainer>
                                                        </TableCell>
                                                        <TableCell><Moment format="DD.MM.YYYY" withTitle>{offer.jobOffer.createdOn}</Moment></TableCell>
                                                        <TableCell><Moment format="DD.MM.YYYY" withTitle>{offer.jobOffer.expirationDate}</Moment></TableCell>
                                                    </TableRow>) :
                                                <TableRow>
                                                    <TableCell>{t('noApplicationsYet')}</TableCell> {/* Translated text */}
                                                </TableRow>}
                                        </TableBody>
                                    </Table>
                                </Grid>
                            </Paper>
                        </Grid>
                    </Grid>
                </div>
            );
        }
    }
}

// Wrap the component with withTranslation HOC
export default withTranslation()(
    withStyles(styles, { withTheme: true })(
        connect(
            state => state.profiles,
            dispatch => bindActionCreators(profileActionCreators, dispatch)
        )(EmployerOffers)
    )
);

//import React, { Component } from 'react';
//import { withStyles } from '@material-ui/core/styles';
//import { Typography, Paper, Button, Grid, Table, TableHead, TableRow, TableCell, TableBody, CircularProgress } from '@material-ui/core';
//import { connect } from 'react-redux';
//import { bindActionCreators } from 'redux';
//import { profileActionCreators } from '../../actions/profileActionCreators';
//import { getLoggedUser } from '../../helpers';
//import { LinkContainer } from 'react-router-bootstrap';
//import Moment from 'react-moment';


//const styles = theme => ({
//    root: {
//        paddingTop: theme.spacing.unit * 2,
//        [theme.breakpoints.down("xs")]: {
//            marginLeft: -50,
//            marginRight: -50
//        }
//    },
//    heading: {
//        marginBottom: 40,
//        marginTop: 40,
//    },
//});

//class EmployerOffers extends Component {
//    constructor(props) {
//        super(props);
//        this.state = {
//        };
//    }

//    componentWillMount() {
//        const loggedUser = getLoggedUser();

//        this.props.requestStudentWithOffers(loggedUser.id);
//    }

//    render() {
//        const { classes, theme, isLoading } = this.props;
//        const loggedUser = getLoggedUser();
//        const student = this.props.student;

//        if (!loggedUser && !loggedUser.token) {
//            return (null);
//        } else {

//            return (isLoading ? <CircularProgress /> : 
//                <div>
//                    <Grid
//                        container
//                        spacing={0}
//                        alignItems="center"
//                        justify="center"
//                    >
//                        <Grid item xs={8}>
//                            <Paper className={classes.root}>
//                                <Typography variant="h4" align="center" className={classes.heading}>
//                                    Моите обяви
//                                </Typography>
//                                <Grid item xs={12}>
//                                    <Table>
//                                        <TableHead>
//                                            <TableRow>
//                                                <TableCell>Заглавие</TableCell>
//                                                <TableCell>Качена на</TableCell>
//                                                <TableCell>Изтича на</TableCell>
//                                            </TableRow>
//                                        </TableHead>
//                                        <TableBody>
//                                            {student.jobsAppliedFor && student.jobsAppliedFor.length > 0 ?
//                                                student.jobsAppliedFor.map(offer => 
//                                                    <TableRow key={offer.jobOffer.id}>
//                                                        <TableCell>
//                                                            <LinkContainer to={`/job/details/${offer.jobOffer.id}`} exact>
//                                                                <Button>{offer.jobOffer.title}</Button>
//                                                            </LinkContainer>
//                                                        </TableCell>
//                                                        <TableCell><Moment format="DD.MM.YYYY" withTitle>{offer.jobOffer.createdOn}</Moment></TableCell>
//                                                        <TableCell><Moment format="DD.MM.YYYY" withTitle>{offer.jobOffer.expirationDate}</Moment></TableCell>
//                                                    </TableRow>) :
//                                                <TableRow>
//                                                    <TableCell>Вие не сте кандидатствали все още.</TableCell>
//                                                </TableRow>}
//                                        </TableBody>
//                                    </Table>                                   
//                                </Grid>                               
//                            </Paper>
//                        </Grid>
//                    </Grid>                    
//                </div>
//            );
//        }
//    }
//}

//export default withStyles(styles, { withTheme: true })(connect(
//    state => state.profiles,
//    dispatch => bindActionCreators(profileActionCreators, dispatch)
//)(EmployerOffers));